var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close",
    clipPath: "url(#clip0_26695_4232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.7338 0.340254C11.3788 -0.0146943 10.8055 -0.0146943 10.4505 0.340254L6 4.78167L1.54949 0.331153C1.19454 -0.0237958 0.62116 -0.0237958 0.266212 0.331153C-0.0887372 0.686102 -0.0887372 1.25948 0.266212 1.61443L4.71672 6.06494L0.266212 10.5155C-0.0887372 10.8704 -0.0887372 11.4438 0.266212 11.7987C0.62116 12.1537 1.19454 12.1537 1.54949 11.7987L6 7.34822L10.4505 11.7987C10.8055 12.1537 11.3788 12.1537 11.7338 11.7987C12.0887 11.4438 12.0887 10.8704 11.7338 10.5155L7.28328 6.06494L11.7338 1.61443C12.0796 1.26858 12.0796 0.686102 11.7338 0.340254Z",
    fill: "#CE121F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26695_4232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.0649414)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.8c342899cdbe2a96247aef0bd2580a1e.svg";
export { ForwardRef as ReactComponent };